// Only code specific to this site should be here. Anything that can be used across multiple sites
// should be pushed into the KMS.
// const bootstrap = window.bootstrap;
import Splide from "@splidejs/splide";
import { ProportionalImageNormalisation } from "@keodesign/proportional-image-normalisation";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import GLightbox from "glightbox";


export function init() {
	setupTestimonialSlider();
	setupBlockSlider();
	ProportionalImageNormalisation(".scale-me", 120, 0.525);
	setupSponsorAutoScroll();
	setupFeatureList();
	setupLightbox();
}


export function setupBlockSlider(){
	var testimonialSlider = document.querySelectorAll(".block-slider");
	
	if(testimonialSlider){
		for (var i = 0; i < testimonialSlider.length; i++ ) {
			var slider = testimonialSlider[i].querySelector(".slider");
			
			new Splide( slider, {
				type   : "slide",
				rewind    : true,
				pagination: true,
				arrows    : false,
				autoplay: true,
			}).mount();
		}
	}
}


export function setupLightbox(){
	GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: true
	});
}


export function setupFeatureList(){
	const featureList = document.querySelectorAll(".feature-list > h4");
	let firstFlag = true;
	featureList.forEach(feature => {
		feature.addEventListener("click", ()=>{
			const feature_content = document.querySelector("#feature-" + feature.dataset.id);
			if (feature_content){

				const content_list = document.querySelectorAll(".feature-content");
				content_list.forEach(_feature_content => {
					_feature_content.classList.remove("active");
				});

				feature_content.classList.add("active");
			}
		});
		if (firstFlag){
			firstFlag = false;
			feature.click();
		}
	});
}


export function setupTestimonialSlider(){
	var testimonialSlider = document.querySelectorAll(".testimonial-slider");
	
	if(testimonialSlider){
		for (var i = 0; i < testimonialSlider.length; i++ ) {
			var slider = testimonialSlider[i].querySelector(".slider");
			
			new Splide( slider, {
				type   : "slide",
				rewind    : true,
				pagination: true,
				arrows    : false,
				autoplay: true,
			}).mount();
		}
	}
}

export function setupSponsorAutoScroll(){
	var elms = document.getElementsByClassName("partner-autoscroll");
	for ( var i = 0; i < elms.length; i++ ) {
		new Splide( elms[i], {
			type   : "loop",
			drag   : "free",
			pagination: false,
			arrows    : false,
			gap:20,
			focus  : "center",
			perPage: 6,
			autoScroll: {
				speed: 1,
				rewind: true
			},
			mediaQuery : "max",
			breakpoints: {
				1200: {
					perPage: 5,
				},
				976: {
					perPage: 4,
				},
				768: {
					perPage: 3,
				},
				576: {
					perPage: 2,
				},
				300: {
					perPage: 1,
				},
			}
		}).mount( { AutoScroll } );
	}
}

window.addEventListener("DOMContentLoaded", init);